module.exports = __webpack_public_path__ + "images/stickers/clock.274b27f64c02ca0cd705.png";